import { gql } from '@apollo/client';

export const GET_PACKAGES = gql`
  query GetPackages {
    getPackages {
      _id
      packageType
      name
      amount
      products {
        _id
        productName
        amount
        questions
        scope
        description
        isActive
        isAddOn
      }
    }
  }
`;

export const GET_PRODUCTS = gql`
  query GetProducts {
    getProducts {
      _id
      productName
      amount
      questions
      scope
      description
      isActive
      isAddOn
    }
  }
`;
